export default __webpack_public_path__ + "static/media/nus-logo.308b842b.png";